import baseAxios from "../axios-service";

export default {
  getItemByHash(hashId) {
    return baseAxios.get(`/programs/hash/${hashId}`);
  }
};
